import type { GridColumnPropsExtended } from "@/Domain/GridColumnPropsExtended";
import type {
  WorkbookSheetRow,
  WorkbookOptions,
  WorkbookSheet,
  WorkbookSheetColumn,
} from "@progress/kendo-vue-excel-export";
import moment from "moment";

const getMaxRowLength = function getMaxRowLength(rows: WorkbookSheetRow[]) {
  return rows.reduce((max, row) => {
    return Math.max(max, row.cells?.length ?? 0);
  }, 0);
};

export const initializeColumns = function initializeColumns(
  options: WorkbookOptions
) {
  if (!options.sheets) return;

  options.sheets.forEach((sheet: WorkbookSheet) => {
    if (!sheet.rows || !sheet.rows || !sheet.rows[0]) return;
    const cellTemplate =
      sheet.columns?.[0] ??
      ({
        autoWidth: true,
      } as WorkbookSheetColumn);

    const length = getMaxRowLength(sheet.rows);

    if (!sheet.columns)
      sheet.columns = Array.from({ length }, () => cellTemplate);
    else {
      sheet.columns = Array.from(
        { length },
        (i: number) => sheet.columns![i] ?? cellTemplate
      );
    }
  });
};

export const copyRowsToSheet = function copyRowsToSheet(
  options: WorkbookOptions,
  tempOptions: WorkbookOptions,
  sheetIndex: number = -1
) {
  if (!options.sheets || !tempOptions.sheets) return;

  if (sheetIndex === -1) sheetIndex = options.sheets.length - 1;

  const sheet = options.sheets[sheetIndex];
  if (!sheet) return;

  tempOptions.sheets.forEach((tempSheet: WorkbookSheet) => {
    if (!tempSheet.rows) return;

    sheet.rows?.push({});
    tempSheet.rows.forEach((row: WorkbookSheetRow) => {
      sheet.rows?.push(row);
    });
  });
};

export const setDateColumnsFormat = function setDateColumnsFormat<T>(
  columns: GridColumnPropsExtended[] | undefined,
  data: T[]
) {
  if (!columns || !data || !data.length) return;

  const dateColumns = columns.filter((c) => c.type === "date" && c.field);

  for (const column of dateColumns) {
    const format =
      column.format?.replace("{0:", "").replace("}", "").replace("dd", "DD") ??
      "";
    // (column as any).cellOptions = {
    //   format: format,
    // };
    for (const item of data) {
      const mDate = moment(
        new Date(item[column.field! as keyof T] as any as string)
      );
      (item[column.field as keyof T] as any as Date | string) =
        mDate.format(format);
    }
  }
};
